import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, User } from '@isophi/core-legacy';
import { Child, StateEnum, TeacherAdditionalInfoService } from '@isophi/pap-api';
import { NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, finalize } from 'rxjs';

import { MoreInfoFormComponent } from '../../shared/components/more-info-form/more-info-form.component';
import { RouterLinkFactory } from '../router/router-link.factory';
import { ChildService } from './child.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  titleChanged$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  smallTextTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  subtitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  backArrow$ = new BehaviorSubject<boolean>(false);

  showHeader$ = new BehaviorSubject<boolean>(true);

  private child: Child | null = null;

  constructor(
    private childService: ChildService,
    private spinner: NgxSpinnerService,
    private links: RouterLinkFactory,
    private router: Router,
    private parentAdditionalInfoService: TeacherAdditionalInfoService,
    private modal: NgbModal,
    private authService: AuthService,
    private ngbDateParserFormatter: NgbDateParserFormatter
  ) {}

  setSmallTextTitle(smallText: string): void {
    this.smallTextTitle$.next(smallText);
  }

  clearSmallTextTitle(): void {
    this.smallTextTitle$.next('');
  }
  setSubtitle(subtitle: string): void {
    this.subtitle$.next(subtitle);
  }

  clearSubtitle(): void {
    this.subtitle$.next('');
  }

  setTitle(customTitle?: string): void {
    const title = customTitle ?? '';
    this.titleChanged$.next(title);
  }

  showBackArrow() {
    this.backArrow$.next(true);
  }
  hideBackArrow() {
    this.backArrow$.next(false);
  }

  // Formate selection data
  prepareData(dataObject: { [key: string]: string }, enumObject: any): { [key: string]: string }[] {
    const data = [];
    for (const val in enumObject) {
      const value = enumObject[val];
      // Try both keys: value (e.g. '0-2') and val (e.g. '_02')
      const text = dataObject[value] ?? dataObject[val] ?? value;
      data.push({ text, value });
    }
    return data;
  }

  formateDate(date): string | null {
    return date ? this.ngbDateParserFormatter.format(date) : null;
  }

  parseDate(date: string | null): NgbDateStruct {
    return date ? this.ngbDateParserFormatter.parse(date) : null;
  }

  fillQuestionnaire(): void {
    this.spinner.show();

    const actorUuid = this.authService.loggedUser;

    this.spinner.hide();
    this.router.navigate(this.links.fillQuestionnaire(actorUuid));
  }

  deleteChild(): void {
    if (this.child) {
      this.childService.deleteChild(this.child.uuid).subscribe();
    }
  }

  checkAdditionalInfo(): void {
    this.spinner.show();
    this.parentAdditionalInfoService
      .teacherAdditionalInfoCheckAdditionalInfoRetrieve()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe((val) => {
        if (val) {
          this.fillQuestionnaire();
        } else {
          this.modal.open(MoreInfoFormComponent, { size: 'lg', centered: true });
        }
      });
  }

  hasUserKindergarten(loggedUser: User | null): boolean {
    return loggedUser?.teacher?.kindergartenIds.length > 0;
  }

  getTagImageUrl(url: string | null | undefined): string {
    return url ? `${environment.materialServer}${url}` : '';
  }

  getStateEnumColor(state: StateEnum): string {
    switch (state) {
      case StateEnum.InProcess:
        return '#A8D81B';
      case StateEnum.Finished:
        return '#9EB544';
      case StateEnum.Incomplete:
        return '#DD382C';
      case StateEnum.Waiting:
        return '#FF8806';
    }
  }
}
